export default {
    completedBag: 'CompletedBag',
    completedFlight: 'CompletedFlight',
    completedReflight: 'CompletedReflight',
    future: 'Future',
    missed: 'Missed',
};
